import { createDraftSafeSelector } from '@reduxjs/toolkit';

export const changeLogSelector = (state) => state.changeLog.activityLog;
const loading = (state) => state.changeLog.loading;

export const selectActivityLog = createDraftSafeSelector(
  [changeLogSelector],
  (activityLog) => activityLog,
);

export const selectLoading = createDraftSafeSelector(
  [loading],
  (loading) => loading,
);
